import $ from 'jquery';

if (document.readyState !== 'loading') {
  initApplicationForm();
} else {
  document.addEventListener('DOMContentLoaded', function () {
      initApplicationForm();
  });
}

function initApplicationForm() {

  // Add additional career options to the dropdown
  const careersSelect = document.querySelector('select[name="careers"]');
  if (careersSelect) {
    // Add "Position" as the first option
    const positionOption = document.createElement('option');
    positionOption.value = '';
    positionOption.textContent = 'Position';
    positionOption.disabled = true;
    positionOption.selected = true;
    positionOption.hidden = true;
    careersSelect.insertBefore(positionOption, careersSelect.firstChild);
    
    // Add "Apply for a future role" as the last option
    const openRoleOption = document.createElement('option');
    openRoleOption.value = 'Open Role';
    openRoleOption.textContent = 'Apply for a future role';
    careersSelect.appendChild(openRoleOption);
  }

  const fileInputs = [
      { inputId: 'file-resume', labelClass: '.label-resume', maxSizeMB: 2 },
      { inputId: 'file-coverletter', labelClass: '.label-coverletter', maxSizeMB: 2 }
  ];

  // Check if any file inputs exist
  const hasFileInputs = fileInputs.some(({ inputId }) => document.getElementById(inputId));
  if (!hasFileInputs) return;


  // Function to handle file selection and update labels
  function handleFileSelection(fileInput, labelElement, maxSizeMB) {
      // Function to check if file size is within limit
      function isFileSizeAllowed(file) {
          const maxSizeBytes = maxSizeMB * 1024 * 1024; // Convert MB to bytes
          return file.size <= maxSizeBytes;
      }

      // Function to check if file type is allowed
      function isFileTypeAllowed(file) {
          try {
              // Handle undefined, empty or malformed accept attribute
              const acceptedTypes = (fileInput.accept || '*').split(',').map(type => type.trim());
              if (acceptedTypes.includes('*')) return true; // Accept all files if no restrictions

              // Convert file type to match the format in accept attribute
              const fileType = file.type || '';
              const fileExtension = file.name ? '.' + file.name.split('.').pop().toLowerCase() : '';

              return acceptedTypes.some(type => {
                  try {
                      if (type.startsWith('.')) {
                          // Check file extension
                          return type.toLowerCase() === fileExtension.toLowerCase();
                      } else if (type.includes('/*')) {
                          // Handle mime type wildcards (e.g., image/*)
                          const [category] = type.split('/');
                          return fileType.startsWith(category + '/');
                      } else {
                          // Check exact mime type
                          return type === fileType;
                      }
                  } catch (err) {
                      return false; // Reject on error for safety
                  }
              });
          } catch (err) {
              return false; // Reject on error for safety
          }
      }

      // Function to reset the file input and label
      function resetFileInput() {
          fileInput.value = ''; // Clear the file input
          const labelParagraphs = labelElement.querySelectorAll('p');
          const labelIcon = labelElement.querySelector('.label-icon');
          // Reset the first paragraph to default text
          if (labelParagraphs[0]) {
              labelParagraphs[0].textContent = 'Click to upload or drag and drop PDF (Max 2MB)';
          }

          // Show the file size limit text
          if (labelParagraphs[1]) {
              labelParagraphs[1].style.display = 'block';
          }

          // Show the label icon
          if (labelIcon) {
              labelIcon.style.display = 'block';
          }

          // Remove the selected class
          labelElement.classList.remove('file-selected');

          // Hide the remove button
          const removeButton = labelElement.querySelector('.remove-file');
          if (removeButton) {
              removeButton.style.display = 'none';
          }
      }

      // Create and append remove button if it doesn't exist
      let removeButton = labelElement.querySelector('.remove-file');
      if (!removeButton) {
          removeButton = document.createElement('button');
          removeButton.type = 'button';
          removeButton.className = 'remove-file';
          removeButton.innerHTML = '×';

          removeButton.style.display = 'none';
          labelElement.classList.add('has-remove-button');
          labelElement.appendChild(removeButton);
      }

      // Add click handler to remove button
      removeButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          resetFileInput();
      });

      fileInput.addEventListener('change', function() {
          const file = this.files[0];
          if (file) {
              if (!isFileTypeAllowed(file)) {
                  alert('This file type is not allowed');
                  resetFileInput();
                  return;
              }
              if (!isFileSizeAllowed(file)) {
                  alert(`File size must be less than ${maxSizeMB}MB`);
                  resetFileInput();
                  return;
              }
              // Get the label paragraphs
              const labelParagraphs = labelElement.querySelectorAll('p');
              const labelIcon = labelElement.querySelector('.label-icon');

              // Update the first paragraph with the file name
              if (labelParagraphs[0]) {
                  labelParagraphs[0].textContent = file.name;
              }

              // Hide the file size limit text
              if (labelParagraphs[1]) {
                  labelParagraphs[1].style.display = 'none';
              }

              // Hide the label icon
              if (labelIcon) {
                  labelIcon.style.display = 'none';
              }

              // Add a selected class to the label for styling
              labelElement.classList.add('file-selected');

              // Show the remove button
              removeButton.style.display = 'block';
          }
      });

      // Handle drag and drop
      labelElement.addEventListener('dragover', function(e) {
          e.preventDefault();
          e.stopPropagation();
          this.classList.add('dragover');
      });

      labelElement.addEventListener('dragleave', function(e) {
          e.preventDefault();
          e.stopPropagation();
          this.classList.remove('dragover');
      });

      labelElement.addEventListener('drop', function(e) {
          e.preventDefault();
          e.stopPropagation();
          this.classList.remove('dragover');

          const files = e.dataTransfer.files;
          if (files.length) {
              fileInput.files = files;
              // Trigger the change event manually
              const event = new Event('change');
              fileInput.dispatchEvent(event);
          }
      });
  }

  // Initialize each file input-label pair
  fileInputs.forEach(({ inputId, labelClass, maxSizeMB }) => {
      const input = document.getElementById(inputId);
      const label = document.querySelector(labelClass);
      if (input && label) {
          handleFileSelection(input, label, maxSizeMB);
      }
  });
};



